import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a5b345c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0a5b345c&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=0a5b345c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b345c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050store/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5b345c')) {
      api.createRecord('0a5b345c', component.options)
    } else {
      api.reload('0a5b345c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a5b345c&scoped=true", function () {
      api.rerender('0a5b345c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/food/index.vue"
export default component.exports